<template>
  <div
    id="kt_header_mobile"
    class="kt-header-mobile kt-header-mobile--fixed"
  >
    <div class="kt-header-mobile__logo">
      <router-link to="/">
        <img style="height: 3rem;" src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" alt="" />
      </router-link>
    </div>
    <div class="kt-header-mobile__toolbar">
      <button class="kt-header-mobile__toggler kt-header-mobile__toggler--left" id="kt_aside_mobile_toggler" @click="toggleSideBar">
        <span></span>
      </button>

      <button class="kt-header-mobile__toggler" id="kt_header_mobile_toggler" @click="toggleTopBar">
        <span></span>
      </button>

      <button class="kt-header-mobile__topbar-toggler" id="kt_header_mobile_topbar_toggler" ref="kt_header_mobile_topbar_toggler">
        <i class="flaticon-more"></i>
      </button>
    </div>
  </div>
</template>

<script>
import KTToggle from "@/assets/js/toggle.js";

export default {
  name: "HeaderMobile",
  methods: {
    toggleSideBar() {
      document.body.classList.remove("kt-header-menu-wrapper--on");
      document.body.classList.toggle("kt-aside--on");
      document.getElementById('kt_header_menu_wrapper').classList.remove("kt-header-menu-wrapper--on");
      document.getElementById('kt_aside').classList.toggle("kt-aside--on");
    },
    toggleTopBar() {
      document.body.classList.remove("kt-aside--on");
      document.body.classList.toggle("kt-header-menu-wrapper--on");
      document.getElementById('kt_aside').classList.remove("kt-aside--on");
      document.getElementById('kt_header_menu_wrapper').classList.toggle("kt-header-menu-wrapper--on");
    }
  },
  mounted() {
    new KTToggle(this.$refs["kt_header_mobile_topbar_toggler"], {
      target: "body",
      targetState: "kt-header__topbar--mobile-on",
      togglerState: "kt-header-mobile__toolbar-topbar-toggler--active"
    });
  }
};
</script>
